import request from "@/utils/requestJSON";

export function getSiteMap() {
  return request({
    url: "/storage/Menu/SiteMap.json",
    method: "get",
  });
}

export function getHotKeyword() {
  return request({
    url: "/storage/Menu/HotKeyword.json",
    method: "get",
  });
}

export function getInfoSecurity() {
  return request({
    url: "/storage/Menu/InfoSecurity.json",
    method: "get",
  });
}

export function getDecree() {
  return request({
    url: "/storage/Menu/Decree.json",
    method: "get",
  });
}

export function getMenuEN() {
  return request({
    url: "/storage/Menu/MenuEN.json",
    method: "get",
  });
}

export function getMenuJP() {
  return request({
    url: "/storage/Menu/MenuJP.json",
    method: "get",
  });
}
